import { render, staticRenderFns } from "./users.page.vue?vue&type=template&id=1820bbc6&"
import script from "./users.page.vue?vue&type=script&lang=js&"
export * from "./users.page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports